import { Module } from 'wrapper6'

const $ = jQuery

export default class WoocommerceScroll extends Module {
  ready (app) {
    $.scroll_to_notices = function (scrollElement) {
      if (scrollElement.length) {
        $('html, body').animate({ scrollTop: (scrollElement.offset().top - 90) }, 1000)
      }
    }
  }
}
